import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/truligo.com/proxio-fe/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoggerProvider"] */ "/var/www/truligo.com/proxio-fe/src/page-components/LoggerContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/truligo.com/proxio-fe/src/page-components/Search/SearchHeader/SearchHeader.tsx");
